// import { LogLevel } from "@azure/msal-browser";

export const b2cPolicies = {
    names: {
        signUpSignIn: 'b2c_1a_susi_idbg',
        editProfile: 'b2c_1a_susi_idbg',
    },
    authorities: {
        signUpSignIn: {
            authority: process.env.REACT_APP_B2C_AUTHORITY!,
        },
    },
    authorityDomain: process.env.REACT_APP_B2C_DOMAIN!,
};

// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENT_ID!,
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        tokenEndpoint: process.env.REACT_APP_B2C_TOKEN_ENDPOINT!,
        knownAuthorities: [b2cPolicies.authorities.signUpSignIn.authority],
        redirectUri: process.env.REACT_APP_REDIRECT_URL!,
        postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URL!,
        grant_type: 'authorization_code',
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};

// Scopes you add here will be prompted for consent during login
export const loginRequest = {
    scopes: ['openid', 'profile', `${process.env.REACT_APP_B2C_SCOPE!}`],
};

/**
 * Enter here the coordinates of your web API and scopes for access token request
 * The current application coordinates were pre-registered in a B2C tenant.
 */
export const apiConfig = {
    scopes: ['https://msidlabb2c.onmicrosoft.com/msidlabb2capi/read'],
    uri: 'https://msidlabb2c.onmicrosoft.com/msidlabb2capi',
};
